
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prediction",
      function () {
        return require("private-next-pages/prediction/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prediction"])
      });
    }
  